import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Auth } from "@MODULES";
import "./index.scss";
import moment from "moment";

const PublicLayout = () => {
  const year = moment().year();
  return (
    <div className="app-public-layout">
      <Switch>
        <Route path="/auth" component={Auth}></Route>
        <Route path="*">
          <Redirect to="/auth/login" />
        </Route>
      </Switch>
      <div className="copyright">&copy; {year} hepsiJET v1.2</div>
    </div>
  );
};

export default PublicLayout;
